export const UPDATE_SEARCH_RENT_DATA = 'searchRenteData/UPDATE_SEARCH_RENT_DATA';
export const EMPTY_SEARCH_RENT_DATA = 'searchRenteData/EMPTY_SEARCH_RENT_DATA';
const initialState = {
    searchRentData:{
        searchRent:[{
            createPeopleName:'', //创建人名称
            createOn:'',         //创建时间
            createPeoplePhone:'', //电话
            districtId:'',        //小区
            rentalMode:'',       //合租
            minPrice:'',         //最低价
            maxPrice:'',         //最高价
            bldroomCount:'',     //室
            hallCount:'',        //厅
            minArea:'',          //最小面积
            maxArea:'',          //最大面积
            decorationLevel:'',  //装修标准
            checkInDate:'',     //入住日期
            checkInAmount:'',   //入住人数
        }],
        textPrefix:'',
        district:"",
        rent:'',
        area:'',
        houseType:'',
        warm_type:'',
        layer_levels:'',
        house_orientations:'',
        decoration_levels:'',
        checkInAmount:'',
        sort:'createTime',
        rentMoneyStart:'',              //租金区间开始
        rentMoneyEnd:'',                //租金区间开始
        areaStart:'',                   //面积区间开始
        areaEnd:'',                     //面积区间开始
        houseData:[],
        sortSc:'desc',   // 默认倒序
        numberShow:false,
        numberShowArr:[],
        sex:'',
        rentalMode:'',
        midNo:[],
    },
};
const searchRentDataDataReducer =  (searchRentData=0, action)=>{
    switch (action.type) {
        case UPDATE_SEARCH_RENT_DATA:
            return {
                ...searchRentData,
                [action.subType]:action.data
            }
        case EMPTY_SEARCH_RENT_DATA:
          let obj = {
                  searchRent:[{
                      createPeopleName:'', //创建人名称
                      createOn:'',         //创建时间
                      createPeoplePhone:'', //电话
                      districtId:'',        //小区
                      rentalMode:'',       //合租
                      minPrice:'',         //最低价
                      maxPrice:'',         //最高价
                      bldroomCount:'',     //室
                      hallCount:'',        //厅
                      minArea:'',          //最小面积
                      maxArea:'',          //最大面积
                      decorationLevel:'',  //装修标准
                      checkInDate:'',     //入住日期
                      checkInAmount:'',   //入住人数
                  }],
                  textPrefix:'',
                  district:"",
                  rent:'',
                  area:'',
                  houseType:'',
                  warm_type:'',
                  layer_levels:'',
                  house_orientations:'',
                  decoration_levels:'',
                  checkInAmount:'',
                  sort:'createTime',
                  rentMoneyStart:'',              //租金区间开始
                  rentMoneyEnd:'',                //租金区间开始
                  areaStart:'',                   //面积区间开始
                  areaEnd:'',                     //面积区间开始
                  houseData:[],
                  sortSc:'desc',   // 默认倒序
                  numberShow:false,
                  numberShowArr:[],
                  sex:'',
                  rentalMode:'',
              }
            return obj
        default:
            return searchRentData
    }
}
export default (state = initialState, action) => {
    return {
        searchRentData : searchRentDataDataReducer(state.searchRentData, action)
    };
}
export const dispatch_func = {
    update_searchRentData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_SEARCH_RENT_DATA,
                data:data,
                subType:type
            });
        }
    },
    empty_searchRentData : (data,type) => {
        return dispatch => {
            dispatch({
                type: EMPTY_SEARCH_RENT_DATA,
                data:data,
                subType:type
            });
        }
    },
};


// WEBPACK FOOTER //
// ./src/modules/searchRentInfo.js